/* eslint-disable react/prop-types */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/interactive-supports-focus */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable react/jsx-props-no-spreading */
import { Grid } from "antd";
import React, { useCallback, useEffect, useState } from "react";
import MegaMenuOld from "./MegaMenuOld";
import ChildrenMenu from "./components/ChildrenMenu";
import MainMenu from "./components/MainMenu";

const MegaMenu = (props) => {
  const { homeurl, megacta, search, sitemegamenu } = props;
  // Breakpoints
  const { useBreakpoint } = Grid;
  const screens = useBreakpoint();
  const { xl } = screens;
  const [activeMenu, setActiveMenu] = useState(null);
  const handleKeyDown = useCallback(
    (event) => {
      // close menu on "esc" key press
      if (event.key === "Escape") {
        setActiveMenu(null);
      }
    },
    [setActiveMenu],
  );
  // add "esc" key event listener on mount
  useEffect(() => {
    //  add event listener
    // eslint-disable-next-line no-undef
    document.addEventListener("keydown", handleKeyDown);
    return () => {
      // remove event listener
      // eslint-disable-next-line no-undef
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, [handleKeyDown]);

  if (!sitemegamenu) {
    return <MegaMenuOld {...props} />;
  }

  const homeUrl = `${homeurl}/?s`;

  return (
    <React.Fragment>
      <div className="megamenu__top">
        {xl && megacta && (
          <ul className="megamenu__top menu">
            {megacta.map((item) => (
              <li>
                <a href={item.url}>{item.title}</a>
              </li>
            ))}
          </ul>
        )}
        <MainMenu
          {...props}
          activeMenu={activeMenu}
          setActiveMenu={setActiveMenu}
        />
        <div className="buttons">
          <ul className="d-flex align-items-center">
            <li>
              <a
                className="btn muotolevy-button__md search js-muotolevy-search-header"
                href={homeUrl}
                onClick={() => setActiveMenu(null)}
              >
                <img src={search} alt="search" />
              </a>
            </li>
          </ul>
        </div>
      </div>
      {activeMenu && <ChildrenMenu {...props} parentMenu={activeMenu} />}
    </React.Fragment>
  );
};

export default MegaMenu;
